@if (form) {
  <form class="whitelist-entries-container" [formGroup]="form">
    <app-ice-alert iconWidth="2rem" type="info" [iconName]="IconNames.ice_junior">
      <div heading>Ring tre nummer gratis</div>
      <div>
        Med iceJunior kan man ringe 3 valgfrie nummer i Norge. Disse kan også legges til og endres på Min Side eller i
        Ice-appen.
      </div>
    </app-ice-alert>
    <div class="whitelist-entries-form-input-container">
      <app-ice-input-field
        formControlName="whitelistEntry1"
        label="Gratisnummer 1"
        ngDefaultControl
        textTestId="whitelist-phone-number-1-input"
        [errorOnTouchedOnly]="true"
        [errorText]="getMsisdnErrorText(whiteListEntry1Controls?.errors)"
        [maxLength]="8"
      />
      <app-ice-input-field
        formControlName="whitelistEntry2"
        label="Gratisnummer 2"
        ngDefaultControl
        textTestId="whitelist-phone-number-2-input"
        [errorOnTouchedOnly]="true"
        [errorText]="getMsisdnErrorText(whiteListEntry2Controls?.errors)"
        [maxLength]="8"
      />
      <app-ice-input-field
        formControlName="whitelistEntry3"
        label="Gratisnummer 3"
        ngDefaultControl
        textTestId="whitelist-phone-number-3-input"
        [errorOnTouchedOnly]="true"
        [errorText]="getMsisdnErrorText(whiteListEntry3Controls?.errors)"
        [maxLength]="8"
      />
    </div>
  </form>
}
